import React, { useState } from 'react';

import { db } from './firebase'

import { collection, query, where, doc, updateDoc } from "firebase/firestore";
import { useCollection } from 'react-firebase-hooks/firestore';
import { Link, useOutletContext } from 'react-router-dom';

export default function Home() {
    const { uid, profile } = useOutletContext();

    // Only the hunts this player is a member of.
    const [myHunts, loading, error] = useCollection(
        query(collection(db, "hunts"), where("memberIds", "array-contains", uid))
    );

    const [name, setName] = useState(profile.displayName ?? "");

    async function saveName() {
        const trimmed = name.trim();
        if (trimmed && trimmed !== profile.displayName) {
            await updateDoc(doc(db, "players", uid), { displayName: trimmed });
        }
    }

    return (
        <div>
            <h1>Scav Hunt Central</h1>

            <p>
                Welcome,{" "}
                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onBlur={saveName}
                    aria-label="Your display name"
                />
            </p>

            <p>
                <Link to="/create">+ Create a new hunt</Link>
            </p>

            <h2>Your hunts</h2>

            {loading && <p>Loading…</p>}
            {error && <p>Error: {error.message}</p>}

            {myHunts && myHunts.empty && (
                <p>You're not in any hunts yet. Create one above, or open an invite link a friend shared with you.</p>
            )}

            <ul>
                {myHunts && [...myHunts.docs]
                    .sort((a, b) => (b.data().startDate?.seconds ?? 0) - (a.data().startDate?.seconds ?? 0))
                    .map((h) => {
                        const d = h.data();
                        const isOwner = d.ownerId === uid;
                        const fmt = (ts) => ts && new Date(ts.seconds * 1000)
                            .toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
                        const start = fmt(d.startDate), end = fmt(d.endDate);
                        const dateLabel = start && end ? `${start} – ${end}` : (start || end || "");
                        return (
                            <li key={h.id}>
                                <Link to={"/play/" + h.id}>{d.displayName}</Link>
                                {dateLabel && (
                                    <span style={{ fontSize: "0.8em", color: "#888", marginLeft: 6 }}>
                                        {dateLabel}
                                    </span>
                                )}
                                {" · "}
                                <Link to={"/gallery/" + h.id}>gallery</Link>
                                {isOwner && <>{" · "}<Link to={"/manage/" + h.id}>manage</Link></>}
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
}
